// src/Header.js
import React from 'react';

function Header() {
  const asciiArt = `
         8888888b.  d8b 888     888 Y88b   d88P 
         888   Y88b Y8P 888     888  Y88b d88P  
         888    888     888     888   Y88o88P   
 .d88b.  888   d88P 888 Y88b   d88P    Y888P    
d88""88b 8888888P"  888  Y88b d88P      888     
888  888 888        888   Y88o88P       888     
Y88..88P 888        888    Y888P        888     
 "Y88P"  888        888     Y8P         888     
   `;
  return (
    <header className="bg-black text-green-400 border-b border-green-500 py-3">
      <div className="container mx-auto flex justify-between items-center">
        <div className="text-2xl font-mono">  {/* Adjusted text size */}
          <pre className="whitespace-pre">{asciiArt}</pre>
        </div>
        <nav>
          {/* Navigation links here */}
        </nav>
      </div>
    </header>
  );
}

export default Header;